import React from 'react';

import { useGet } from '../../hooks/useSWR';
import { CodeDemo } from './CodeDemo';
import { DemoType } from './types';

interface Props {
  url: string;
  height?: number;
  allowLayoutChange?: boolean;
}

export const EmbeddableCodeDemo = ({
  url,
  height = 500,
  allowLayoutChange = false,
  ...otherProps
}: Props) => {
  const { data: apiResponse, error, isLoading } = useGet(`/api/demo/${url}`);

  if (isLoading) {
    return <>Loading...</>;
  }

  if (error) {
    return <>Error: {error.message}</>;
  }

  const data = apiResponse?.data || {};

  return (
    <CodeDemo
      {...otherProps}
      data={data as DemoType}
      isEmbed
      allowLayoutChange={allowLayoutChange}
      url={`/demos/${url}`}
      height={height}
    />
  );
};
